import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = { class: "profile-info d-sm-flex align-items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://shop.raceya.fit/wp-content/uploads/2020/11/logo-placeholder.jpg",
  class: "rounded",
  alt: "user"
}, null, -1)
const _hoisted_5 = { class: "title mt-12 mt-sm-0" }
const _hoisted_6 = { class: "text-black fw-medium mb-8" }
const _hoisted_7 = { class: "d-block fs-md-15 fs-lg-16 text-dark-emphasis mb-8" }
const _hoisted_8 = { class: "d-block fw-bold text-primary" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "border-top mt-15 mb-15 mt-sm-20 mb-sm-20 mt-md-25 mb-md-25 mt-lg-30 mb-lg-30" }, null, -1)
const _hoisted_10 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-medium text-black-emphasis mb-0" }, "Project Information", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "ph-duotone ph-pencil text-black position-relative top-1 fs-16 me-1" }, null, -1)
const _hoisted_13 = { class: "info mt-25 ps-0 mb-0 list-unstyled" }
const _hoisted_14 = { class: "position-relative" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-primary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-web" })
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Project Description", -1)
const _hoisted_17 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_18 = { class: "position-relative" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-success rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-mail-inbox-app" })
], -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Enquiry ID", -1)
const _hoisted_21 = { class: "d-inline-block fs-md-15 fs-lg-16 text-primary" }
const _hoisted_22 = { class: "position-relative" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-info rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-telephone-call" })
], -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Status", -1)
const _hoisted_25 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_26 = { class: "position-relative" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-primary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-web" })
], -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Salesperson", -1)
const _hoisted_29 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_30 = { class: "position-relative" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-primary rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-web" })
], -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Business Area", -1)
const _hoisted_33 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_34 = { class: "position-relative" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-industry" })
], -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Project Value", -1)
const _hoisted_37 = { class: "d-inline-block fs-md-15 fs-lg-16 text-muted" }
const _hoisted_38 = { class: "position-relative" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "icon text-warning rounded-circle text-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sun" })
], -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "d-block text-black mb-5 fw-semibold" }, "Basecamp Status", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h5", _hoisted_6, _toDisplayString(_ctx.clientName), 1),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.enquiryID), 1),
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.salesman), 1)
        ])
      ]),
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode(_component_router_link, {
          to: "/lead-details",
          class: "d-inline-block text-decoration-none lh-1 text-muted fw-medium"
        }, {
          default: _withCtx(() => [
            _hoisted_12,
            _createTextVNode(" Edit ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("ul", _hoisted_13, [
        _createElementVNode("li", _hoisted_14, [
          _hoisted_15,
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.projectDescription), 1)
        ]),
        _createElementVNode("li", _hoisted_18, [
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.enquiryID), 1)
        ]),
        _createElementVNode("li", _hoisted_22, [
          _hoisted_23,
          _hoisted_24,
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.status), 1)
        ]),
        _createElementVNode("li", _hoisted_26, [
          _hoisted_27,
          _hoisted_28,
          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.salesman), 1)
        ]),
        _createElementVNode("li", _hoisted_30, [
          _hoisted_31,
          _hoisted_32,
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.businessArea), 1)
        ]),
        _createElementVNode("li", _hoisted_34, [
          _hoisted_35,
          _hoisted_36,
          _createElementVNode("span", _hoisted_37, " £" + _toDisplayString(_ctx.formattedProjectValue), 1)
        ]),
        _createElementVNode("li", _hoisted_38, [
          _hoisted_39,
          _hoisted_40,
          (_ctx.basecampProjectID)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "d-inline-block fs-md-15 fs-lg-16 text-muted",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPopup && _ctx.openPopup(...args))),
                style: {"cursor":"pointer","color":"blue","text-decoration":"underline"}
              }, " Connected "))
            : (_openBlock(), _createElementBlock("span", {
                key: 1,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.callSetMode && _ctx.callSetMode(...args))),
                style: {"cursor":"pointer","text-decoration":"underline"},
                class: "d-inline-block fs-md-15 fs-lg-16 text-muted"
              }, " Disconnected "))
        ])
      ])
    ])
  ]))
}